import angular from 'angular';
import UserAccountService from './userAccountService.service';

let UserAccountServiceModule = angular.module('userAccountService', []).service('userAccountService', UserAccountService);

export
default UserAccountServiceModule;


// WEBPACK FOOTER //
// ./app/common/userAccountService/userAccountService.js